module.exports = __webpack_public_path__ + "img/header_logo.9a554f9e.png";